import React, { ComponentProps } from "react";

import UserContextValueProvider from "../../Providers/Value/UserContextValueProvider";
import SsoForm from "../Components/AuthenticationForms/SsoForm";
import SsoReauthenticationForm from "../Components/AuthenticationForms/SsoReauthenticationForm";
import Reauthenticator, { IReauthenticatorFormProps } from "../Components/Reauthenticator";
import useGetGemOAuthToken from "../Hooks/UseGetGemOAuthToken";
import useGetOAuthCode from "../Hooks/UseGetOAuthCode";

const useGetOAuthIdentity = () => useGetGemOAuthToken({ UseGetCode: useGetOAuthCode });

const GemSsoReauthenticationForm: React.FC<IReauthenticatorFormProps> = props =>
  SsoReauthenticationForm({ ...props, useGetOAuthIdentity, AuthForm: SsoForm });

const SsoReauthenticator: React.FC<Omit<ComponentProps<typeof Reauthenticator>, "AuthForm">> = props =>
  Reauthenticator({ ...props, AuthForm: GemSsoReauthenticationForm });

/**
 * An {@link SsoReauthenticationForm} which uses the {@link useGetGemOAuthToken} hook to obtain the client token and
 * the {@link SsoForm} to prompt the user to execute the oAuth process.
 */
const UserContextSsoReauthenticator: React.FC = UserContextValueProvider<
  ComponentProps<typeof SsoReauthenticator>,
  ComponentProps<typeof SsoReauthenticator>
>({
  Component: SsoReauthenticator,
  map: ({ showReauthenticator, setShowReauthenticator, setToken }) => {
    return {
      show: showReauthenticator,
      onChange: setToken,
      setShow: setShowReauthenticator
    };
  }
});

export default UserContextSsoReauthenticator;
